import { BaseRestDataProvider } from './BaseRestDataProvider';
import { GanttChartPlan } from '../models/GanttChartPlan';
import { ProjectEstimateItem } from '../models/ProjectEstimateItem';
import { ProjectRiskItem } from '../models/ProjectRiskItem';
import { CostGroup } from '../models/CostGroup';
import { ProjectRequirement } from '../models/ProjectRequirement';
import { ProjectAssumption } from '../models/ProjectAssumption';

export interface ProjectScenario {
  id?: string;
  projectId: string;
  name: string;
  requirements: ProjectRequirement[];
  ganttChartPlan: GanttChartPlan;
  estimateItems: ProjectEstimateItem[];
  riskItems: ProjectRiskItem[];
  costGroups: CostGroup[];
  assumptions: ProjectAssumption[];
}

export class ProjectsScenariosRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/projectscenarios');
  }

  getAll(): Promise<ProjectScenario[]> {
    return this.get<ProjectScenario[]>(``);
  }

  getById(id: string): Promise<ProjectScenario> {
    return this.get<ProjectScenario>(`/${id}`);
  }

  create(project: ProjectScenario): Promise<ProjectScenario> {
    return this.post<ProjectScenario>(``, project);
  }

  update(id: string, project: ProjectScenario): Promise<void> {
    return this.put<void>(`/${id}`, project);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}
